import { v4 as uuid4 } from "uuid";
import { TableElement } from "../types";

export const createTableElement = (id: string = uuid4()): TableElement => ({
  id,
  kind: "table",
  columns: [{ key: "A", name: "A" }],
  data: [{}],
});
